<template>
	<div class="mainRoot">
			<div class="part1" @click="toPath('/product')">
				<div class="threejs">
					<!-- <div class="fakeLight"></div> -->
					<earth></earth>
				</div>
				<span class="font1">3D GIS</span>
				<span class="font2">更逼真、更丰富的三维展示系统</span>
			</div>
			<div class="part2">
				<div class="leftSide" @click="toPath('/product')">
					<span class="font3">大数据可视化</span>
					<span class="font4">多维度统计分析，秒级处理、实时更新</span>
					<div class="leftSideSubImg"></div>
				</div>
				<div class="rightSide" @click="toPath('/samples')">
					<span class="font5">数字孪生</span>
					<span class="font6">全生命周期映射，智慧城市新生态</span>
					<div class="rightSideSubImg"></div>
				</div>
			</div>
			<div class="part3" @click="toPath('/aboutUs')">
				<span class="font7">数据治理</span>
				<span class="font8">海量异构数据处理、运算、分析</span>
			</div>
	</div>
</template>

<script>
import Earth from '@/components/Earth.vue'
export default{
	name:'Main',
	components:{
		Earth
	},
	mounted() {
		document.title = '时空视界|时空大数据可视化解决方案'
	},
	methods: {
		toPath(path){
			this.$router.push(path)
			window.scrollTo(0,0)
		}
	}
}
</script>
<style scoped="scoped">
	/* .fakeLight{
		width: 1920px;
		height: 886px;
		background-image: url(../../assets/cloud2.png);
		background-position: 800px 200px;
		background-size: 1920px 886px;
		position: absolute;
	} */
	.threejs{
		width: 1920px;
		height: 886px;
		position: absolute;
		z-index: -1;
		overflow: hidden;
	}
	.font8{
		width: 100%;
		/* height: 20px; */
		font-size: 20px;
		/* font-family: oppo; */
		color: #D3D3D3;
		line-height: 30px;
		display: block;
		margin-top: 19px;
		/* margin-left: 814px; */
		text-align: center;
	}
	.font7{
		width: 100%;
		/* height: 50px; */
		font-size: 50px;
		/* font-family: oppo; */
		font-weight: 500;
		color: #FFFFFF;
		line-height: 75px;
		letter-spacing: 2px;
		display: block;
		padding-top: 50px;
		/* margin-left: 855px; */
		text-align: center;
	}
	.part3{
		width: 1920px;
		height: 917px;
		margin-top: 20px;
		background-image: url(../../assets/main/pic_sjzl.jpg);
		background-size: cover;
		cursor: pointer;
	}
	.rightSideSubImg{
		width: 960px;
		height: 349px;
		background-image: url(../../assets/main/pic_shuziluansheng.png);
		background-size: contain;
		background-repeat: no-repeat;
		position: relative;
		margin: 0 auto;
		margin-top: 351.01px;
		margin-left: 151px;
	}
	.font6{
		width: 100%;
		font-size: 20px;
		/* font-family: oppo; */
		color: #D3D3D3;
		line-height: 30px;
		display: block;
		text-align: center;
		margin-top: 19px;
		float: left;
	}
	.font5{
		width: 100%;
		font-size: 50px;
		/* font-family: oppo; */
		font-weight: 500;
		color: #ffffff;
		line-height: 75px;
		letter-spacing: 2px;
		display: block;
		text-align: center;
		margin-top: 50px;
		float: left;
	}
	.leftSideSubImg{
		width: 960px;
		height: 349px;
		background-image: url(../../assets/main/pic_keshihua.png);
		background-size: contain;
		background-repeat: no-repeat;
		position: relative;
		margin: 0 auto;
		margin-top: 351.01px;
		margin-left: 146px;
	}
	.font4{
		width: 100%;
		font-size: 20px;
		/* font-family: oppo; */
		color: #666666;
		line-height: 30px;
		display: block;
		text-align: center;
		margin-top: 19px;
		float: left;
	}
	.font3{
		width: 100%;
		font-size: 50px;
		/* font-family: oppo; */
		font-weight: 500;
		color: #000000;
		line-height: 75px;
		letter-spacing: 2px;
		display: block;
		text-align: center;
		margin-top: 50px;
		float: left;
	}
	.leftSide{
		width: 960px;
		height: 700px;
		/* position: absolute; */
		background-image: url(../../assets/main/bg_keshihua.jpg);
		background-size: cover;
		overflow: hidden;
		float: left;
		cursor: pointer;
	}
	.rightSide{
		width: 960px;
		height: 700px;
		/* position: absolute; */
		/* margin-left: 972px; */
		background-image: url(../../assets/main/bg_shuziluansheng.jpg);
		background-size: cover;
		overflow: hidden;
		float: left;
		cursor: pointer;
	}
	.part2{
		width: 1920px;
		height: 700px;
		margin-top: 20px;
	}
	
	.font2{
		z-index: 1;
		width: 100%;
		font-size: 24px;
		/* font-family: oppo; */
		color: #B9B9B9;
		line-height: 36px;
		letter-spacing: 1px;
		display: block;
		text-align: center;
		margin-top: 25px;
	}
	.font1{
		z-index: 1;
		width: 100%;
		font-size: 60px;
		/* font-family: oppo; */
		font-weight: 500;
		color: #FFFFFF;
		line-height: 90px;
		letter-spacing: 3px;
		display: block;
		/* margin-left: 858px; */
		text-align: center;
		padding-top: 75px;
	}
	.part1{
		width: 1920px;
		height: 886px;
		/* background-image: url(../../assets/main/pic_3d%20gis.jpg); */
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		cursor: pointer;
	}
	.mainRoot{
		/* text-align: center; */
		/* min-width: 1300px; */
		width: 1920px;
	}
</style>
